<template>
  <div>
    <AppLocationModal>
      <div class="p-4 sticky z-30 top-0 bg-white">
        <h1 class="font-bold text-2xl md:text-3xl" v-html="$t('fat.location.heading')" />
      </div>
      <div class="px-4 pb-24 sm:pb-4">
        <AppLocationGeo class="mb-6" v-if="route.name.startsWith('fat')" />
        <AppLocationPopularCities class="mb-6" />
        <AppLocationCities />
      </div>
      <div class="p-4 grid gap-4 sticky z-30 bottom-0 bg-white text-sm">
        <button class="button-coral" @click="useUpdateQuery({ locationModal: undefined })" :class="{ 'pointer-events-none': fat.pending }" data-style="coral">
          {{ $t('fat.location.button', { count: route.name.startsWith('fat') ? fat.total : '' }) }}
        </button>
      </div>
    </AppLocationModal>
  </div>
</template>

<script setup>
const route = useRoute()
const fat = useFatStore()
</script>